// extracted by mini-css-extract-plugin
module.exports =  {"list":"_025a50318d--list--giT8C","list-element":"_025a50318d--list-element--wEqv2","list-element--active":"_025a50318d--list-element--active--Fl6Qb"};